import { Typography } from '@stern-ui/ui';
import { createColumnHelper } from '@tanstack/react-table';

import { TableConfigType } from '@/components/PatientDataTable';
import { formatLongDateTime } from '@/utils';

import { PATIENT_DETAILS } from '../../patientDetails/consts';
import { FetchPatientNoteHistoryLogResponse } from '../../patientDetails/types';

const columnHelper = createColumnHelper<FetchPatientNoteHistoryLogResponse>();

const columns = [
	columnHelper.accessor<'created_at', string>('created_at', {
		header: () => (
			<Typography variant='bodySmall'>
				{PATIENT_DETAILS.CONFIGS.PATIENT_HISTORY.TABLE.COLUMNS.A.LABEL}
			</Typography>
		),
		cell: (info) => {
			return formatLongDateTime(info.getValue());
		},
	}),
	columnHelper.accessor<'note_content', string>('note_content', {
		header: () => (
			<Typography variant='bodySmall'>
				{PATIENT_DETAILS.CONFIGS.PATIENT_HISTORY.TABLE.COLUMNS.B.LABEL}
			</Typography>
		),
		cell: (info) => info.getValue() || null,
	}),
	columnHelper.accessor<'created_by_name', string>('created_by_name', {
		header: () => (
			<Typography variant='bodySmall'>
				{PATIENT_DETAILS.CONFIGS.PATIENT_HISTORY.TABLE.COLUMNS.C.LABEL}
			</Typography>
		),
		cell: (info) => info.getValue() || null,
	}),
];

export const patientHistoryTableConfig: TableConfigType = {
	columns,
	rowProps: { rowSelect: false },
};
